<template>
    <div style="position: relative;">
        <div class="main-page">
            <div class="line-box">
                <a class="contack-link" :href="lineCustomer" target="_blank">
                    <img class="line-icon" :src="require('../../assets/icon/line.png')" />
                </a>
            </div>
            <div class="account-box" v-if="showLogin">
                <div class="forgot" @click="toForgot">
                    {{ GLOBAL.lanLocal['forgotpassword'] }}
                </div>
                <div class="login-box">
                    <div class="account"><input class="account-input" v-model="account" type="text"
                            :placeholder="GLOBAL.lanLocal['enteraccount']" /></div>
                    <div class="password"><input class="password-input" v-model="password" type="password"
                            :placeholder="GLOBAL.lanLocal['enterpassword']" /></div>
                    <div @click="reload(false)" class="login-btn">{{ GLOBAL.lanLocal['login'] }}</div>
                    <div @click="toReg" class="reg-btn">{{ GLOBAL.lanLocal['register_upper'] }}</div>
                </div>
            </div>
            <div class="banner">
                <div class="recommendPage">
                    <swiper :options="swiperOption" ref="mySwiper">
                        <swiper-slide v-for="(item, index) in bannerList" :key="index + 1">
                            <img :src="item">
                        </swiper-slide>
                    </swiper>
                </div>
            </div>
            <div class="nav-menu">
                <div class="nav-item" v-for="(item, index) in navmenu" @click="changnav(item.id)">
                    <img class="nav-bg" v-if="navid == item.id" :src="require('../../assets/icon/navmenu-active.png')" />
                    <img class="nav-bg" v-else :src="require('../../assets/icon/navmenu.png')" />
                    <div :key="index + 1" class="nav-link">
                        <img class="nav-img" :src="item.img">
                        <div class="text-wrap" :class="navid == item.id ? 'text-wrap-active' : ''">{{ item.name }}</div>
                    </div>
                </div>
            </div>
            <div class="menu-title">
                <div v-for="(item, index) in navmenu">
                    <div v-if="navid == item.id" :key="index + 1" class="title-box">
                        <img class="title-img" v-if="item.id == 0" :src="require('../../assets/icon/hot.png')" />
                        <div class="title-text">{{ item.name }}</div>
                    </div>
                </div>
            </div>
            <div class="wrap-container">
                <div class="item-content">
                    <div class="view-game-container">
                        <div class="wrap-game-show">
                            <div class="container-list-game-slot">
                                <div class="list-game-bacarat" v-for="(list, index) in gameList" v-if="navid == index">
                                    <template v-for="game in list">
                                        <!-- <div class="game-menu">
                                        <img class="menu-bg" src="../../assets/menu-bg.png" />
                                        <img class="menu-icon" v-if="game.menu" :src="game.menu" />
                                    </div> -->
                                        <div class="game-item no-animate" v-for="item in game.list">
                                            <!-- <a class="card-save" @click="favorite(item)">
                                            <img class="fav-img" :class="isFav(item.gameid) ? 'faving-img' : ''"
                                                :src="require('../../assets/fav.png')" />
                                        </a> -->
                                            <img class="game-img" :src="item.img" />
                                            <!-- <span class="game-name">{{ item.name }}</span> -->
                                            <button type="button" @click="toGame(item.gameid, item.type)"
                                                class="all-btn sq card-hover v-btn v-btn--is-elevated v-btn--has-bg theme--dark v-size--default">
                                                <span class="v-btn__content">
                                                    <span>{{ GLOBAL.lanLocal['playgame'] }}</span>
                                                </span>
                                            </button>
                                        </div>
                                    </template>
                                </div>
                                <!-- <div class="list-game-bacarat" style="margin-top: 1.3rem;" v-if="navid == 7">
                                <div class="game-item no-animate" v-for="item in favList">
                                    <a class="card-save" @click="favorite(item)">
                                        <img class="fav-img" :class="isFav(item.gameid) ? 'faving-img' : ''"
                                            :src="require('../../assets/fav.png')" />
                                    </a>
                                    <img class="game-img" :src="item.img" />
                                    <span class="game-name">{{ item.name }}</span>
                                    <button type="button" @click="toGame(item.gameid, item.type)"
                                        class="all-btn sq card-hover v-btn v-btn--is-elevated v-btn--has-bg theme--dark v-size--default">
                                        <span class="v-btn__content">
                                            <span>{{ GLOBAL.lanLocal['playgame'] }}</span>
                                        </span>
                                    </button>
                                </div>
                            </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import md5 from 'js-md5';
import AES from "../../common/AES.js"
import { doPost } from '../../api/api.js'
import { v4 as uuidv4 } from 'uuid'
import decodeApiLan from '../../api/decodeApiLan.js'
export default {
    name: 'home',
    components: {
        swiper,
        swiperSlide
    },
    data() {
        return {
            swiperOption: {
                loop: true,
                autoplay: {
                    delay: 5000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                }
            },
            navmenu: [],
            gameList: [],
            isSearch: false,
            searchValue: '',
            navid: 0,
            isMasking: false,
            isLoginPage: false,
            isRegisterPage: false,
            isServicePage: false,
            isMyPage: false,
            isForgotPage: false,
            isDepositPage: false,
            isWithdrawPage: false,
            fromW: 0,
            amount: '0.00',
            url: '',
            favList: [],
            favStr: '',
            lineCustomer: '',
            scrollTop: undefined, // 距离顶端的值
            className: 'modalOpen', // 类名
            isShowLan: false,
            loading: true,
            account: '',
            password: '',
            isBindBack: false,
            activityList: [],
            innerHeight: 0,
            showLogin: false,
            bannerList: [
                require('../../assets/banner/1.jpg'),
                require('../../assets/banner/2.jpg'),
                require('../../assets/banner/3.jpg'),
                require('../../assets/banner/4.jpg'),
                require('../../assets/banner/5.jpg'),
                require('../../assets/banner/6.jpg'),
                require('../../assets/banner/7.jpg'),
                require('../../assets/banner/8.jpg'),
                require('../../assets/banner/9.jpg'),
                require('../../assets/banner/10.jpg'),
                require('../../assets/banner/11.jpg'),
                require('../../assets/banner/12.jpg'),
            ],
        }
    },
    created() {
        this.innerHeight = window.innerHeight - 130
        this.setData()
        doPost({
            n: 'AppEx',
            a: 'get_customer_list',
        }).then((res) => {
            if (res.code === 0) {
                let customerList = res.data['customer']
                customerList.forEach((item) => {
                    if (item['CfgType'] == 292) {
                        this.lineCustomer = item['CfgValue']
                        this.GLOBAL.lineCustomer = this.lineCustomer
                    }
                })
            }
        })
        this.setShareid()
        this.reload(true)
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper;
        }
    },
    methods: {
        toForgot() {
            this.$emit('toForgot')
        },
        toReg() {
            this.$emit("reg")
        },
        toEmail() {
            this.$router.push({ path: '/email' })
        },
        toActivity() {
            this.$router.push({ path: '/activity' })
        },
        logout() {
            this.GLOBAL.userInfo.accountid = 0
            this.GLOBAL.userInfo.name = ''
            this.GLOBAL.userInfo.passcode = ''
            localStorage.removeItem(md5('__name__'))
            localStorage.removeItem(md5('__pwd_'))
        },
        setData() {
            this.navmenu = [
                { 'name': this.GLOBAL.lanLocal['gamehit'], 'img': require('../../assets/icon/popular.png'), 'id': 0 },
                { 'name': this.GLOBAL.lanLocal['sport'], 'img': require('../../assets/icon/sport.png'), 'id': 2 },
                { 'name': this.GLOBAL.lanLocal['casino'], 'img': require('../../assets/icon/casino.png'), 'id': 3 },
                { 'name': this.GLOBAL.lanLocal['slot'], 'img': require('../../assets/icon/slot.png'), 'id': 4 },
                { 'name': this.GLOBAL.lanLocal['pokdeng'], 'img': require('../../assets/icon/pokdeng.png'), 'id': 6 },
                { 'name': this.GLOBAL.lanLocal['fish'], 'img': require('../../assets/icon/fish.png'), 'id': 5 },
                { 'name': this.GLOBAL.lanLocal['bitcoin'], 'img': require('../../assets/icon/bitcoin.png'), 'id': 1 },
                // { 'name': this.GLOBAL.lanLocal['favorite'], 'img': require('../../assets/icon/favorite.png'), 'id': 7 }
            ]
            this.gameList = [
                [
                    {
                        'menu': require('../../assets/lucas.png'), 'list': [
                            // { 'name': this.GLOBAL.lanLocal['treasures'], 'img': require('../../assets/lucas/treasures_' + this.GLOBAL.lanCode + '.jpeg'), 'gameid': '1254', 'type': '1' },
                            // { 'img': require('../../assets/lucas/cat_' + this.GLOBAL.lanCode + '.png'), 'gameid': '1255', 'type': '1' },
                            { 'name': this.GLOBAL.lanLocal['aquaman5'], 'img': require('../../assets/lucas/aquaman5_' + this.GLOBAL.lanCode + '.png'), 'gameid': '2229', 'type': '1' },
                            { 'name': this.GLOBAL.lanLocal['goldentoad'], 'img': require('../../assets/lucas/goldentoad_' + this.GLOBAL.lanCode + '.png'), 'gameid': '2225', 'type': '1' },
                            { 'name': this.GLOBAL.lanLocal['godwealth2'], 'img': require('../../assets/lucas/godwealth2_' + this.GLOBAL.lanCode + '.png'), 'gameid': '1253', 'type': '1' },
                            { 'name': this.GLOBAL.lanLocal['fivedragons'], 'img': require('../../assets/lucas/fivedragons_' + this.GLOBAL.lanCode + '.png'), 'gameid': '1252', 'type': '1' },
                            { 'name': this.GLOBAL.lanLocal['baccarat2'], 'img': require('../../assets/lucas/baccarat2_' + this.GLOBAL.lanCode + '.png'), 'gameid': '1100', 'type': '1' },
                        ]
                    }
                ],
                [
                    {
                        'menu': require('../../assets/sa.png'), 'list': [
                            { 'name': 'Dragon Tiger', 'img': require('../../assets/sa/dragontiger_' + this.GLOBAL.lanCode + '.png'), 'gameid': '4101', 'type': '2' },
                            { 'name': 'Sic Bo', 'img': require('../../assets/sa/sicbo_' + this.GLOBAL.lanCode + '.png'), 'gameid': '4102', 'type': '2' },
                            { 'name': 'Black Jack', 'img': require('../../assets/sa/blackjack_' + this.GLOBAL.lanCode + '.png'), 'gameid': '4103', 'type': '2' },
                            { 'name': 'Pok Deng', 'img': require('../../assets/sa/pokdenggame_' + this.GLOBAL.lanCode + '.png'), 'gameid': '4104', 'type': '2' },
                            { 'name': this.GLOBAL.lanLocal['round'], 'img': require('../../assets/sa/round_' + this.GLOBAL.lanCode + '.png'), 'gameid': '4105', 'type': '2' },
                            { 'name': 'Teen Patt', 'img': require('../../assets/sa/teenpatt_' + this.GLOBAL.lanCode + '.png'), 'gameid': '4106', 'type': '2' },
                            { 'name': 'Andar Bahar', 'img': require('../../assets/sa/andarbahar_' + this.GLOBAL.lanCode + '.png'), 'gameid': '4107', 'type': '2' },
                            { 'name': 'Baccarat', 'img': require('../../assets/sa/baccarat_' + this.GLOBAL.lanCode + '.png'), 'gameid': '4108', 'type': '2' }
                        ]
                    },
                    {
                        'menu': require('../../assets/sp.png'), 'list': [
                            { 'name': 'Baccarat', 'img': require('../../assets/sp/Baccarat-sp.png'), 'gameid': '4201', 'type': '3' },
                            { 'name': 'Color SicBo', 'img': require('../../assets/sp/ColorSicBo.png'), 'gameid': '4202', 'type': '3' },
                            { 'name': 'Fishermen Gold', 'img': require('../../assets/sp/FishermenGold.png'), 'gameid': '4203', 'type': '3' },
                            { 'name': 'Lustrous Ocean', 'img': require('../../assets/sp/LustrousOcean.png'), 'gameid': '4204', 'type': '3' },
                            { 'name': 'Pula-Puti', 'img': require('../../assets/sp/Pula-Puti.png'), 'gameid': '4205', 'type': '3' },
                            { 'name': 'Shake Shake', 'img': require('../../assets/sp/ShakeShake.png'), 'gameid': '4206', 'type': '3' },
                        ]
                    }
                ],
                [
                    {
                        'menu': require('../../assets/3sing.png'), 'list': [
                            { 'name': '3 Sing Sport', 'img': require('../../assets/ss/3sing.png'), 'gameid': '4301', 'type': '4' },
                        ]
                    }
                ],
                [
                    {
                        'menu': require('../../assets/lucas.png'), 'list': [
                            { 'name': this.GLOBAL.lanLocal['sicbo2'], 'img': require('../../assets/lucas/sicbo2_' + this.GLOBAL.lanCode + '.png'), 'gameid': '1102', 'type': '1' },
                            { 'name': this.GLOBAL.lanLocal['russianroulette'], 'img': require('../../assets/lucas/russianroulette_' + this.GLOBAL.lanCode + '.png'), 'gameid': '1101', 'type': '1' },
                            { 'name': this.GLOBAL.lanLocal['benzbmw'], 'img': require('../../assets/lucas/benzbmw_' + this.GLOBAL.lanCode + '.png'), 'gameid': '500', 'type': '1' },
                            { 'name': 'Birds and Beasts', 'img': require('../../assets/lucas/birdsbeasts_' + this.GLOBAL.lanCode + '.png'), 'gameid': '1109', 'type': '1' },
                        ]
                    }
                ],
                [
                    {
                        'menu': require('../../assets/lucas.png'), 'list': [
                            // { 'name': this.GLOBAL.lanLocal['treasures'], 'img': require('../../assets/lucas/treasures_' + this.GLOBAL.lanCode + '.jpeg'), 'gameid': '1254', 'type': '1' },
                            // { 'img': require('../../assets/lucas/cat_' + this.GLOBAL.lanCode + '.png'), 'gameid': '1255', 'type': '1' },
                            { 'name': this.GLOBAL.lanLocal['godwealth2'], 'img': require('../../assets/lucas/godwealth2_' + this.GLOBAL.lanCode + '.png'), 'gameid': '1253', 'type': '1' },
                            { 'name': this.GLOBAL.lanLocal['godwealth'], 'img': require('../../assets/lucas/godwealth_' + this.GLOBAL.lanCode + '.png'), 'gameid': '1240', 'type': '1' },
                            { 'name': this.GLOBAL.lanLocal['fivedragons'], 'img': require('../../assets/lucas/fivedragons_' + this.GLOBAL.lanCode + '.png'), 'gameid': '1252', 'type': '1' },
                            { 'name': this.GLOBAL.lanLocal['fivetigers'], 'img': require('../../assets/lucas/fivetigers_' + this.GLOBAL.lanCode + '.png'), 'gameid': '1251', 'type': '1' },
                            { 'name': this.GLOBAL.lanLocal['ninelines'], 'img': require('../../assets/lucas/ninelines_' + this.GLOBAL.lanCode + '.png'), 'gameid': '1220', 'type': '1' },
                        ]
                    }
                ],
                [
                    {
                        'menu': require('../../assets/lucas.png'), 'list': [
                            { 'name': this.GLOBAL.lanLocal['aquaman5'], 'img': require('../../assets/lucas/aquaman5_' + this.GLOBAL.lanCode + '.png'), 'gameid': '2229', 'type': '1' },
                            { 'name': this.GLOBAL.lanLocal['goldentoad'], 'img': require('../../assets/lucas/goldentoad_' + this.GLOBAL.lanCode + '.png'), 'gameid': '2225', 'type': '1' },
                            { 'name': this.GLOBAL.lanLocal['aquaman2'], 'img': require('../../assets/lucas/aquaman2_' + this.GLOBAL.lanCode + '.png'), 'gameid': '2226', 'type': '1' },
                        ]
                    }
                ],
                [
                    {
                        'menu': require('../../assets/lucas.png'), 'list': [
                            { 'name': this.GLOBAL.lanLocal['baccarat2'], 'img': require('../../assets/lucas/baccarat2_' + this.GLOBAL.lanCode + '.png'), 'gameid': '1100', 'type': '1' },
                            { 'name': this.GLOBAL.lanLocal['dragontiger2'], 'img': require('../../assets/lucas/dragontiger2_' + this.GLOBAL.lanCode + '.png'), 'gameid': '1111', 'type': '1' },
                            { 'name': this.GLOBAL.lanLocal['redblack'], 'img': require('../../assets/lucas/redblack_' + this.GLOBAL.lanCode + '.png'), 'gameid': '1112', 'type': '1' },
                            { 'name': this.GLOBAL.lanLocal['fivestar'], 'img': require('../../assets/lucas/fivestar_' + this.GLOBAL.lanCode + '.png'), 'gameid': '1115', 'type': '1' },
                            { 'name': this.GLOBAL.lanLocal['texaspoke'], 'img': require('../../assets/lucas/texaspoke_' + this.GLOBAL.lanCode + '.png'), 'gameid': '1190', 'type': '1' },
                            { 'name': this.GLOBAL.lanLocal['flopmachine'], 'img': require('../../assets/lucas/flopmachine_' + this.GLOBAL.lanCode + '.png'), 'gameid': '1106', 'type': '1' },
                        ]
                    }
                ]
            ]
        },
        setShareid() {
            var url = window.location.href
            var dz_url = url.split('#')[0]
            var cs = dz_url.split('?')[1]
            if (cs) {
                var cs_arr = cs.split('&')
                var cs = {}
                for (let index = 0; index < cs_arr.length; index++) {
                    cs[cs_arr[index].split('=')[0]] = cs_arr[index].split('=')[1]
                }
                let shareid = cs['accountid']
                if (shareid) {
                    localStorage.setItem(md5("__shareid___"), shareid)
                    doPost({
                        n: 'AppShare',
                        a: 'add_share',
                        accountid: shareid,
                        udid: this.GLOBAL.deviceid
                    }).then((res) => {

                    })
                }
            }
        },
        // 打开弹层 要做的事
        afterOpen() {
            this.scrollTop = document.scrollingElement.scrollTop;
            document.body.classList.add(this.className);
            document.body.style.top = `-${this.scrollTop}px`;
        },
        // 弹层关闭之前 要做的事
        beforeClose() {
            document.body.classList.remove(this.className);
            document.scrollingElement.scrollTop = this.scrollTop;
        },
        func1() {
        },
        favorite(item) {
            if (item.fav) {
                this.favStr = this.favStr.replace(item.gameid + ',', '')
                this.favStr = this.favStr.replace(',' + item.gameid, '')
                this.favStr = this.favStr.replace(item.gameid, '')
            } else {
                if (this.favStr != '') {
                    this.favStr += ','
                }
                this.favStr += item.gameid
            }
            this.genFavList()
            localStorage.setItem(md5(this.GLOBAL.userInfo.name + "__favList___"), this.favStr)
        },
        isFav(gameid) {
            let isFav = false
            let favArr = this.favStr.split(",")
            if (favArr.length > 0) {
                favArr.forEach(item => {
                    if (gameid == item) {
                        isFav = true
                    }
                });
            }
            return isFav
        },
        genFavList() {
            let favArr = this.favStr.split(",")
            this.favList = []
            this.gameList.forEach((list, index) => {
                list.forEach((game, index2) => {
                    game.list.forEach((item, index3) => {
                        this.gameList[index][index2].list[index3]['fav'] = false
                        if (favArr.length > 0) {
                            favArr.forEach(gameid => {
                                if (item['gameid'] == gameid) {
                                    this.gameList[index][index2].list[index3]['fav'] = true

                                    var isExist = false
                                    this.favList.forEach((fav) => {
                                        if (fav['gameid'] == gameid) {
                                            isExist = true
                                        }
                                    })

                                    if (!isExist) {
                                        this.favList.push(item)
                                    }
                                }
                            });
                        }
                    })
                })
            });

        },
        toGame(gameid, type) {
            if (this.GLOBAL.userInfo.name && this.GLOBAL.userInfo.pwd) {
                this.loading = true
                let arr = gameid.split(',')
                let num = Math.random() * (arr.length - 1)
                gameid = arr[num]
                let name = this.GLOBAL.userInfo.name
                let pwd = this.GLOBAL.userInfo.pwd
                let callback = window.location.origin + "/#/callback"
                doPost({
                    n: 'AppGame',
                    a: 'get_game_url',
                    mobile: name,
                    password: pwd,
                    type: type,
                    KindID: gameid,
                    callback: callback,
                    lan: this.GLOBAL.lanCode
                }).then((res) => {
                    if (res.code === 0) {
                        let url = res.data.url
                        this.$emit("toGame", url)
                    } else {
                        const data = decodeApiLan(res, this.GLOBAL.lanArr);
                        this.$toast.error(data.message, {
                            position: "top-center",
                            timeout: 2000,
                            closeOnClick: true,
                            pauseOnFocusLoss: true,
                            pauseOnHover: true,
                            draggable: true,
                            draggablePercent: 0.6,
                            showCloseButtonOnHover: false,
                            hideProgressBar: true,
                            closeButton: false,
                            icon: true,
                            rtl: false
                        });
                    }
                    this.loading = false
                })
            } else {
                this.toSignin()
            }
        },
        changnav(id) {
            this.navid = id
        },
        toSignin() {
            this.$emit("signin")
        },
        reload(isAuto) {
            this.loading = true
            this.url = ""
            let that = this
            let name = localStorage.getItem(md5('__name__'))
            let pwd = localStorage.getItem(md5('__pwd_'))
            if (name) {
                name = AES.decrypt(name, this.GLOBAL.apiAesKey)
                if (name) {
                    this.GLOBAL.userInfo.name = name
                }
            } else if (this.account) {
                name = this.account
            }
            if (pwd) {
                pwd = AES.decrypt(pwd, this.GLOBAL.apiAesKey)
                if (pwd) {
                    this.GLOBAL.userInfo.pwd = pwd
                }
            } else if (this.password) {
                pwd = md5(this.password)
            }
            let reg = localStorage.getItem('reg')
            localStorage.removeItem('reg')
            if (name && pwd) {
                doPost({
                    n: 'AppGame',
                    a: 'do_login',
                    mobile: name,
                    password: pwd,
                    isFirst: reg
                }).then((res) => {
                    if (res.code === 0) {
                        localStorage.setItem(md5('__name__'), AES.encrypt(name, that.GLOBAL.apiAesKey))
                        localStorage.setItem(md5('__pwd_'), AES.encrypt(pwd, that.GLOBAL.apiAesKey))

                        that.GLOBAL.userInfo.accountid = res.data.accountid
                        that.GLOBAL.userInfo.nickname = res.data.nickname
                        that.GLOBAL.userInfo.name = name
                        that.GLOBAL.userInfo.passcode = pwd
                        that.amount = res.data.amount

                        this.showLogin = false
                        this.$emit("reload")
                        // let favStr = localStorage.getItem(md5(this.GLOBAL.userInfo.name + "__favList___"))
                        // if (favStr) {
                        //     this.favStr = favStr
                        //     this.genFavList(true)
                        // this.favList = JSON.parse(AES.decrypt(favStr, api_aes_key))
                        // }
                    } else {
                        if (!isAuto) {
                            const data = decodeApiLan(res, this.GLOBAL.lanArr);
                            this.$toast.error(data.message, {
                                position: "top-center",
                                timeout: 2000,
                                closeOnClick: true,
                                pauseOnFocusLoss: true,
                                pauseOnHover: true,
                                draggable: true,
                                draggablePercent: 0.6,
                                showCloseButtonOnHover: false,
                                hideProgressBar: true,
                                closeButton: false,
                                icon: true,
                                rtl: false
                            });
                        } else {
                            this.logout()
                        }
                    }
                    this.loading = false
                })
            } else {
                this.logout()
                this.loading = false
                this.showLogin = true
            }
            // }
        }
    }
}
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.main-page {
    height: 100%;
    width: 100%;
    padding: 60px 0 80px;
    box-sizing: border-box;
}

.line-box:focus-visible {
    outline: none;
}

.line-box {
    position: fixed;
    right: 12px;
    top: 335px;
    z-index: 10;

    .line-icon:focus-visible {
        outline: none;
    }

    .line-icon {
        height: 40px;
        width: 40px;
    }
}

.account-box {
    margin: 4px;

    .forgot {
        color: rgb(255, 182, 0);
        padding-left: 8px;
        text-align: left;
    }

    .login-box {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 4px 6px;

        .account,
        .password {
            margin-right: 6px;
            border-radius: 4px;
            height: 20px;
            border: 1px solid rgb(255, 182, 0);
            display: flex;
            box-sizing: border-box;
        }

        .account {
            width: 30%;
        }

        .password {
            width: 30%;
        }

        .account-input:focus-visible,
        .password-input:focus-visible {
            outline: 0px;
        }

        .account-input,
        .password-input {
            text-align: center;
            border-radius: 4px;
            font-size: 14px;
            width: 100%;
            background-color: #000;
            color: #fff;
            border: none;
            line-height: 1;
        }

        .account-input::placeholder,
        .password-input::placeholder,
        .account-input::-webkit-input-placeholder,
        .password-input::-webkit-input-placeholder,
        .account-input:-moz-placeholder,
        .password-input:-moz-placeholder,
        .account-input::-moz-placeholder,
        .password-input::-moz-placeholder,
        .account-input:-ms-input-placeholder,
        .password-input:-ms-input-placeholder {
            text-align: center;
            color: #999;
            font-size: 12px;
            line-height: 1px;
        }

        .login-btn {
            margin-right: 6px;
            background-color: rgb(255, 182, 0);
            color: #333;
        }

        .reg-btn {
            color: rgb(255, 182, 0);
            background-color: #000;
        }

        .login-btn,
        .reg-btn {
            border: 1px solid rgb(255, 182, 0);
            width: 20%;
            font-size: 12px;
            height: 20px;
            line-height: 1px;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}

.banner {
    width: 100%;
    height: auto;
    font-size: 0;

    img {
        width: 100%;
        height: auto;
    }
}

.nav-menu::-webkit-scrollbar {
    display: none;
}

.nav-menu {
    width: 100%;
    overflow: scroll;
    display: flex;
    padding: 16px;
    box-sizing: border-box;

    .nav-item:not(:last-child) {
        margin-right: 10px;
    }

    .nav-item {
        width: 85px;
        height: 102px;
        position: relative;
        display: flex;
        align-items: center;

        .nav-bg {
            width: 85px;
            height: 102px;
        }

        .nav-link {
            position: absolute;
            top: 14px;
            left: 0;
            width: 85px;

            .nav-img {
                height: 40px;
                width: 53px;
            }

            .text-wrap {
                color: rgb(119, 119, 119);
                font-size: 14px;
                margin-top: 4px;
            }

            .text-wrap-active {
                color: rgb(233, 222, 124);
            }
        }
    }
}

.menu-title {
    padding: 0 20px 11px;
    text-align: left;

    .title-box {
        display: flex;
        align-items: center;
    }

    .title-img {
        width: 19px;
        height: 22px;
    }

    .title-text {
        margin-left: 4px;
        color: #fff;
        font-size: 16px;
    }
}

.wrap-container {
    display: flex;
    margin-bottom: 20px;

    .item-content {
        width: 100%;
        padding: 0 0.5rem;
        margin: auto;

        .view-game-container {
            display: flex;
            flex-wrap: wrap;
            flex-direction: column;

            .side-bar-category {
                width: 100%;
                font-size: 0;

                .menu-side-bar {
                    width: 100%;
                    padding: 0;

                    .nav-menu-side-bar {
                        .nav-side-bar-menu {
                            justify-content: start;
                            flex-wrap: wrap;
                            max-width: 100%;
                            width: 100%;
                            white-space: nowrap;
                            display: flex;
                            list-style: none;
                            padding-left: 0;

                            .width-auto {
                                width: 20% !important;
                                font-size: 12px !important;
                            }

                            .nav-item {
                                margin-top: 0;
                                margin-bottom: 0.7rem;
                                padding: 0 3px;
                                width: 25%;
                                box-sizing: border-box;

                                .nav-link {
                                    width: 100%;
                                    position: relative;
                                    align-items: center;
                                    justify-content: flex-start;
                                    box-shadow: 0 4px 10px rgba(0, 0, 0, .75);
                                    border-radius: 8px;
                                    border: none;
                                    text-decoration: none;
                                    color: hsla(0, 0%, 100%, .8);
                                    transition: all .4s;
                                    padding: 0;
                                    display: flex;
                                    flex-direction: column;

                                    .nav-img {
                                        filter: drop-shadow(0 0 5px #000);
                                        transition: all .2s ease-in-out;
                                        width: 50px;
                                        height: 50px;
                                        -o-object-fit: contain;
                                        object-fit: contain;
                                        z-index: 2;
                                    }

                                    .text-wrap {
                                        z-index: 2;
                                        margin-left: 0;
                                        display: flex;
                                        flex-direction: column;

                                        .text-span {
                                            font-size: 14px;
                                            white-space: nowrap;
                                            width: 100%;
                                            overflow: hidden;
                                            text-overflow: ellipsis;
                                        }
                                    }
                                }

                                .nav-link.active:before {
                                    transform: scaleX(1);
                                    transform-origin: top right;
                                }

                                .nav-link:before {
                                    transform: scaleX(0);
                                    transform-origin: top right;
                                    border-radius: 8px;
                                    content: " ";
                                    display: block;
                                    position: absolute;
                                    top: 0;
                                    right: 0;
                                    bottom: 0;
                                    left: 0;
                                    background: linear-gradient(180deg, #ffdf46, #ffdc42 23.96%, #feeb52 49.48%, #fbc316 71.87%, #f69b09);
                                    z-index: 0;
                                    transition: transform .3s ease;
                                }

                                .nav-link:after {
                                    content: "";
                                    position: absolute;
                                    top: 40%;
                                    right: 0;
                                    transform: translateY(-50%);
                                    width: 3px;
                                    height: 55%;
                                    background: hsla(0, 0%, 100%, .3);
                                    border-radius: 0 20px 20px 0;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

.wrap-banner {
    z-index: 2;
}

.wrap-game-show {
    width: 100%;
}

.container-list-game-slot {
    position: relative;
    min-height: auto;
    display: flex;
    flex-wrap: wrap;
}

.searching-game {
    display: flex;
    justify-content: space-between;
    width: calc(100% - 60px);
    margin-left: auto;
    margin-top: 0.8rem;
    margin-bottom: 0.2rem;
}

.v-input {
    width: 95%;
    margin: auto;
    max-width: 350px;
    align-items: flex-start;
    display: flex;
    flex: 1 1 auto;
    font-size: 16px;
    letter-spacing: normal;
    text-align: left;
    border-radius: 28px;
    position: relative;
}

.v-input__control {
    min-height: 38px;
    display: flex;
    flex-direction: column;
    height: auto;
    flex-grow: 1;
    flex-wrap: wrap;
    min-width: 0;
    width: 100%;
    border-radius: 28px;
}

.v-input__slot {
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
    min-height: 40px;
    background-color: #1e1e1e;
    border-radius: inherit;
    cursor: text;
    align-items: stretch;
    color: inherit;
    display: flex;
    margin-bottom: 0;
    position: relative;
    transition: .3s cubic-bezier(.25, .8, .5, 1);
    width: 100%;
    padding: 0 24px;
    border-radius: 28px;
    box-sizing: border-box;
}

.v-text-field__slot {
    display: flex;
    flex: 1 1 auto;
    position: relative;
    align-items: center;
}

.v-label {
    top: 11;
    transform-origin: top left;
    color: hsla(0, 0%, 100%, .7);
    height: 20px;
    line-height: 20px;
    letter-spacing: normal;
    max-width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    pointer-events: none;
}

.search-input {
    caret-color: auto;
    padding: 4px 0 2px;
    color: #fff;
    max-height: 32px;
    flex: 1 1 auto;
    line-height: 20px;
    max-width: 100%;
    min-width: 0;
    width: 100%;
    background-color: transparent;
    border-style: none;
    border: none;
}

.search-input:focus-visible {
    border-style: none;
    border: none;
    outline: none;
}

.v-input__append-inner {
    margin-left: auto;
    padding-left: 4px;
    align-self: center;
    margin-top: 0;
    display: inline-block;
    line-height: 1;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.v-input__icon {
    align-items: center;
    display: inline-flex;
    height: 24px;
    flex: 1 0 auto;
    justify-content: center;
    min-width: 24px;
    width: 24px;
}

.v-icon {
    align-items: center;
    display: inline-flex;
    font-feature-settings: "liga";
    font-size: 24px;
    justify-content: center;
    letter-spacing: normal;
    line-height: 1;
    position: relative;
    text-indent: 0;
    transition: .3s cubic-bezier(.25, .8, .5, 1), visibility 0s;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    color: #fff;
}

.noshow {
    display: none;
}

.list-game-bacarat {
    display: flex;
    flex-wrap: wrap;
    align-content: baseline;
    width: 100%;
}

.game-menu {
    width: 100%;
    height: 46px;
    display: flex;
    align-items: center;
    position: relative;
    padding: 0 20px;
    margin-top: 1.3rem;

    .menu-bg {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
        width: 100%;
        height: 34px;
        object-fit: fill;
    }

    .menu-icon {
        position: absolute;
        top: 5px;
        left: 10px;
        z-index: 1;
        width: auto;
        height: 24px;
        object-fit: contain;
    }
}

.game-item {
    width: 33.33%;
    height: auto;
    padding: 5px;
    position: relative;
    box-sizing: border-box;

    .v-btn {
        border: none;
        align-items: center;
        border-radius: 4px;
        display: inline-flex;
        flex: 0 0 auto;
        font-weight: 500;
        letter-spacing: .0892857143em;
        justify-content: center;
        outline: 0;
        position: relative;
        text-decoration: none;
        text-indent: 0.0892857143em;
        text-transform: uppercase;
        transition-duration: .28s;
        transition-property: box-shadow, transform, opacity;
        transition-timing-function: cubic-bezier(.4, 0, .2, 1);
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        vertical-align: middle;
        white-space: nowrap;
        height: 36px;
        min-width: 64px;
        position: absolute;
        z-index: 2;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: linear-gradient(180deg, #ffdf46, #ffdc42 23.96%, #feeb52 49.48%, #fbc316 71.87%, #f69b09);
        padding: 0.5rem 0;
        border-radius: 5px;
        width: 70%;
        text-align: center;
        font-weight: 700;
        font-size: 16px;
        color: #212121;
        visibility: hidden;
        opacity: 0;
        transition: visibility .2s, opacity .2s linear;

        .v-btn__content {
            align-items: center;
            color: inherit;
            display: flex;
            flex: 1 0 auto;
            justify-content: inherit;
            line-height: normal;
            position: relative;
            transition: inherit;
            transition-property: opacity;
        }
    }

    .v-btn--is-elevated {
        box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
    }

    .v-btn:before {
        background-color: currentColor;
        border-radius: inherit;
        bottom: 0;
        color: inherit;
        content: "";
        left: 0;
        opacity: 0;
        pointer-events: none;
        position: absolute;
        right: 0;
        top: 0;
        transition: opacity .2s cubic-bezier(.4, 0, .6, 1);
    }
}

.game-item:hover {
    .card-hover {
        display: block;
        visibility: visible;
        opacity: 1;
    }
}

.card-save {
    position: absolute;
    z-index: 2;
    top: 0;
    right: 0;
    border-radius: 8px;
    transition: visibility .2s, opacity .2s linear;
    background: none !important;
    width: 30px;
    height: 30px;
    cursor: pointer;
}

.fav-img {
    width: 100%;
    height: 100%;
    -o-object-fit: contain;
    object-fit: contain;
    filter: grayscale(.9) drop-shadow(0 0 5px #000000);
    mix-blend-mode: screen !important;
    background: none !important;
    border-radius: 10px;
}

.faving-img {
    filter: unset !important;
}

.game-img {
    width: 100%;
    height: 100%;
    border-radius: 10px;
    -o-object-fit: fill;
    object-fit: fill;
    filter: drop-shadow(3px 3px 3px #000);
}

.game-name {
    position: absolute;
    bottom: -7px;
    left: 50%;
    padding: 3px 0 !important;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 3;
    background-color: rgba(0, 0, 0, .7);
    white-space: nowrap;
    width: 93%;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: Noto Sans Thai, Roboto !important;
    font-size: 14px !important;
    color: #fff;
    line-height: 1.5;
}

.profile-content {
    padding-right: 0.5rem;
    display: flex;
    flex-wrap: nowrap;

    .item-container {
        display: flex;

        .item {
            position: relative;
            font-weight: 700;
            font-size: 14px;
            border-radius: 30px;
            margin: 2px;
            padding: 5px 0.5rem 5px 1.5rem;
            margin-right: 0.5rem;
            color: #fff;

            .item-img {
                position: absolute;
                top: 50%;
                left: 5px;
                width: 25px;
                height: 25px;
                -o-object-fit: contain;
                object-fit: contain;
                transform: translate(-50%, -50%);
                filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, .658));
            }

            .v-btn {
                background: none !important;
                box-shadow: none !important;
                width: 20px;
                height: 20px;
                font-size: .875rem;
                color: #fff;
                align-items: center;
                border: none;
                display: inline-flex;
                flex: 0 0 auto;
                font-weight: 500;
                letter-spacing: .0892857143em;
                justify-content: center;
                outline: 0;
                position: relative;
                text-decoration: none;
                text-indent: 0.0892857143em;
                text-transform: uppercase;
                transition-duration: .28s;
                transition-property: box-shadow, transform, opacity;
                transition-timing-function: cubic-bezier(.4, 0, .2, 1);
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
                vertical-align: middle;
                white-space: nowrap;
            }

            .v-btn:before {
                background-color: currentColor;
                border-radius: inherit;
                bottom: 0;
                color: inherit;
                content: "";
                left: 0;
                opacity: 0;
                pointer-events: none;
                position: absolute;
                right: 0;
                top: 0;
                transition: opacity .2s cubic-bezier(.4, 0, .6, 1);
            }

            .v-btn:hover:before {
                opacity: .08;
            }

            .v-btn__content {
                align-items: center;
                color: inherit;
                display: flex;
                flex: 1 0 auto;
                justify-content: inherit;
                line-height: normal;
                position: relative;
                transition: inherit;
                transition-property: opacity;

                .v-icon {
                    color: #fff;
                    font-size: 18px;
                    height: 24px;
                    width: 24px;
                    align-items: center;
                    display: inline-flex;
                    font-feature-settings: "liga";
                    justify-content: center;
                    letter-spacing: normal;
                    line-height: 1;
                    position: relative;
                    text-indent: 0;
                    transition: .3s cubic-bezier(.25, .8, .5, 1), visibility 0s;
                    vertical-align: middle;
                    -webkit-user-select: none;
                    -moz-user-select: none;
                    -ms-user-select: none;
                    user-select: none;
                }
            }
        }
    }
}

.login-page,
.register-page,
.service-page,
.my-page {
    max-height: 90%;
    min-height: 50%;
    width: 100%;
    padding-bottom: 20px;
    background-color: #000;
}

.bind-page,
.deposit-page,
.withdraw-page {
    height: 100%;
    width: 100%;
}

.masking {
    position: fixed;
    top: 60px;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 998;
    height: -moz-calc(100vh - 130px);
    height: -webkit-calc(100vh - 130px);
    height: calc(100vh - 130px);
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.page-masking {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 998;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: flex-start;
    justify-content: center;
}
.swiper-container {
    z-index: 0 !important;
}
.recommendPage .swiper-container {
    position: relative;
    width: 100%;
}

.recommendPage .swiper-container .swiper-slide {
    width: 100%;
    color: #000;
    font-size: 16px;
    text-align: center;
}

/deep/ .mdi-earth::before {
    display: flex !important;
    align-items: center !important;
}

@-webkit-keyframes pulsepulse {
    0% {
        transform: scaleX(1)
    }

    50% {
        transform: scale3d(1.05, 1.05, 1.05)
    }

    to {
        transform: scaleX(1)
    }
}

@keyframes pulsepulse {
    0% {
        transform: scaleX(1)
    }

    50% {
        transform: scale3d(1.05, 1.05, 1.05)
    }

    to {
        transform: scaleX(1)
    }
}

@-webkit-keyframes x-bounceIn-data-v-5966ab82 {

    0%,
    20%,
    40%,
    60%,
    80%,
    to {
        transition-timing-function: cubic-bezier(.215, .61, .355, 1)
    }

    0% {
        transform: scale3d(.7, .7, .7)
    }

    20% {
        transform: scale3d(1.1, 1.1, 1.1)
    }

    40% {
        transform: scale3d(.9, .9, .9)
    }

    60% {
        opacity: 1;
        transform: scale3d(1.03, 1.03, 1.03)
    }

    80% {
        transform: scale3d(.97, .97, .97)
    }

    to {
        opacity: 1;
        transform: scaleX(1)
    }
}

@keyframes x-bounceIn-data-v-5966ab82 {

    0%,
    20%,
    40%,
    60%,
    80%,
    to {
        transition-timing-function: cubic-bezier(.215, .61, .355, 1)
    }

    0% {
        transform: scale3d(.7, .7, .7)
    }

    20% {
        transform: scale3d(1.1, 1.1, 1.1)
    }

    40% {
        transform: scale3d(.9, .9, .9)
    }

    60% {
        opacity: 1;
        transform: scale3d(1.03, 1.03, 1.03)
    }

    80% {
        transform: scale3d(.97, .97, .97)
    }

    to {
        opacity: 1;
        transform: scaleX(1)
    }
}
</style>
  


// WEBPACK FOOTER //
// src/components/home/home.vue